import { render, staticRenderFns } from "./LenonFreemium.vue?vue&type=template&id=d140b8c0&scoped=true&"
import script from "./LenonFreemium.vue?vue&type=script&lang=js&"
export * from "./LenonFreemium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d140b8c0",
  null
  
)

export default component.exports